import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';
import type { HasMany } from '@warp-drive/legacy/model';

export type Item = WithLegacy<{
  name: string | null;
  type: string | null;
  externalId: string | null;
  externalSource: string | null;
  platform: string | null;
  language: string | null;
  enrichedData: Record<string, unknown> | null;
  thumbnailUrl: string | null;
  emoji: string | null;
  matchedCount: number | null;
  moderationStatus: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  mentions: HasMany<import('./mention.ts').Mention>;
  stats: import('./item-stats.ts').ItemStats | null;
  [Type]: 'items';
}>;

export const ItemSchema = withDefaults({
  type: 'items',
  fields: [
    { name: 'name', kind: 'attribute', type: 'string' },
    { name: 'type', kind: 'attribute', type: 'string' },
    { name: 'externalId', kind: 'attribute', type: 'string' },
    { name: 'externalSource', kind: 'attribute', type: 'string' },
    { name: 'platform', kind: 'attribute', type: 'string' },
    { name: 'language', kind: 'attribute', type: 'string' },
    { name: 'enrichedData', kind: 'attribute', type: 'object' },
    { name: 'thumbnailUrl', kind: 'attribute', type: 'string' },
    { name: 'emoji', kind: 'attribute', type: 'string' },
    { name: 'matchedCount', kind: 'attribute', type: 'number' },
    { name: 'moderationStatus', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'updatedAt', kind: 'attribute', type: 'string' },
    {
      name: 'mentions',
      kind: 'hasMany',
      type: 'mentions',
      options: { async: true, inverse: null },
    },
    {
      name: 'stats',
      kind: 'belongsTo',
      type: 'item-stats',
      options: { async: true, inverse: null },
    },
  ],
});
